const STAGES = [
  'sdk_requested', 'sdk_ready', 'sdk_failed', 'widget_open', 'widget_ready',
  'widget_event', 'widget_success', 'widget_error', 'widget_exit',
  'completion_requested', 'completion_succeeded', 'completion_failed',
  'reconciliation_requested', 'completion_recovered', 'reconciliation_failed',
];

function createId() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
    const value = Math.floor(Math.random() * 16);
    return (character === 'x' ? value : (value % 4) + 8).toString(16);
  });
}

export default function createBankLinkDiagnostics(send) {
  const now = () => (typeof performance !== 'undefined' && performance.now
    ? performance.now() : Date.now());
  const started = now();
  const clientAttemptId = createId();
  const seen = {};
  let sequence = 0;
  const report = (stage, suppliedCode) => {
    if (!STAGES.includes(stage) || sequence >= 32) return;
    const code = /^(?:(?:AC|AR)-[0-9]{1,5}|WIDGET_[A-Z_]{1,40})$/.test(suppliedCode || '')
      ? suppliedCode : '';
    const key = `${stage}:${code}`;
    if (seen[key]) return;
    seen[key] = true;
    sequence += 1;
    // No widget payload, contacts, provider token or bank data crosses this boundary.
    try {
      Promise.resolve(send({
        clientAttemptId,
        stage,
        code,
        sequence,
        elapsedMs: Math.floor(Math.min(600000, Math.max(0, now() - started))),
      })).catch(() => null);
    } catch (error) {
      // Diagnostics never become a linking failure or cause a replay.
    }
  };
  report.clientAttemptId = clientAttemptId;
  return report;
}



// WEBPACK FOOTER //
// ./src/helpers/bankLinkDiagnostics.js